<template>
    <div class="a-form-inputs">

        <pre-accident-earnings @update="updatePreAccidentEarnings"></pre-accident-earnings>

        <div v-if="preAccidentEarnings && preAccidentEarningsValid  && !ownPastLosses">
            <h2 class="u-margin-bottom-40">Post-accident Earnings</h2>
            <post-accident-earnings
                    v-for="(period, index) in getPostInjuryIncomePeriods"
                    :index="index"
                    :period="period"
                    :maxIndex="getPostInjuryIncomePeriods.length"
            ></post-accident-earnings>
            <button class="a-button a-button--small" @click="addIncomePeriod('postInjury')">Add Period</button>
        </div>
        <div v-if="preAccidentEarnings && preAccidentEarningsValid && postInjuryIncomePeriodsValid && !ownPastLosses">
            <past-loss-of-earnings-calculator></past-loss-of-earnings-calculator>
        </div>

        <step-button class="u-margin-top-40" :next-valid="isValid"></step-button>

    </div>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex';
    import FormValidator from 'components/form/validator/mixin';
    import {setStepValid} from 'services/routingMethods';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import Modal from 'components/modal/Modal';
    import ModalContent from 'components/modal/ModalContent';
    import ModalInTheWild from 'components/modal/ModalInTheWild';
    import PostAccidentEarnings from './past-loss-of-earnings/PostAccidentEarnings';
    import CurrencyFormat from 'mixins/currencyFormat';
    import PreAccidentEarnings from './past-loss-of-earnings/PreAccidentEarnings';
    import StepButton from 'components/StepButton.vue';
    import PastLossOfEarningsCalculator from "./past-loss-of-earnings/PastLossOfEarningsCalculations";

    export default {
        name: 'past-loss-of-earnings',
        mounted() {
            setStepValid(this.isValid);

            if (this.getPostInjuryIncomePeriods.length === 0) {
                this.addIncomePeriod('postInjury');
            }
        },
        data() {
            return {
                preAccidentEarningsValid: false
            }
        },
        computed: {
            ...mapGetters('personal/claimant', [
                'getPostInjuryIncomePeriods',
                'getPostInjuryIncomePeriodPayments',
                'postInjuryIncomePeriodPaymentsValid',
                'postInjuryIncomePeriodsValid',
                'getIncomeValue'
            ]),
            preAccidentEarnings: {
                get() {
                    return this.getIncomeValue('pastLossOfEarnings');
                },
                set(value) {
                    this.updateIncomeValue('pastLossOfEarning', value)
                },
            },
            ownPastLosses: {
                get() {
                    return this.getIncomeValue('ownPastLosses')
                }
            },
            isValid() {
                if (this.preAccidentEarningsValid && !this.preAccidentEarnings) {
                    return true;
                }
                if (this.preAccidentEarningsValid && this.ownPastLosses) {
                    return true;
                }

                return (
                    this.preAccidentEarningsValid
                    && this.postInjuryIncomePeriodPaymentsValid
                    && this.postInjuryIncomePeriodsValid
                );
            }
        },
        watch: {
            ['isValid']() {
                this.updateValid();
            },
        },
        mixins: [
            FormValidator,
            CurrencyFormat
        ],
        components: {
            PastLossOfEarningsCalculator,
            PreAccidentEarnings,
            Modal,
            ModalContent,
            ModalInTheWild,
            StepButton,
            PostAccidentEarnings
        },
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        methods: {
            ...mapActions('personal/claimant', [
                'addIncomePeriod',
                'updateIncomeValue'
            ]),
            updatePreAccidentEarnings(data) {
                this.preAccidentEarningsValid = data.preAccidentEarningsValid;
                this.preAccidentEarnings = data.preAccidentEarnings;
                this.updateValid();
            },
            updateValid() {
                setStepValid(this.isValid);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PastLossOfEarnings.vue?62bd5551